import { IBaseVariables } from './baseVariables';

export interface IGetGrossProfit {
  page: number;
  pageSize: number;
  plantId?: string;
  type?: string;
  age?: number;
  headerRow?: any;
}

export interface IUpdateCompoundInterest {
  id: string;
  plantId: string;
  type: string;
  age: number;
  mrp: string;
  percentProfit: number;
}

export interface IGetAgeComboBox extends IBaseVariables {
  age?: number;
}

export const GrossProfitVariables = {
  getCbxTpye: (params: any) => {
    return {};
  },
  getCbxGoldAge: (params: any) => {
    return {};
  },

  getGrossProfit: (params: IGetGrossProfit) => {
    const { page, pageSize, age, type, plantId } = params;
    return {
      skip: (page - 1) * pageSize,
      take: pageSize,
      input: {
        ...(Number.isInteger(age) && {
          age: {
            equals: age,
          },
        }),
        ...(plantId && {
          plantId: {
            equals: plantId,
          },
        }),
        ...(type && {
          type: {
            equals: type.toUpperCase(),
          },
        }),
      },
    };
  },

  saveGrossProfit: (params: any) => {
    const {
      id,
      age,
      compoundInterest,
      moneyId,
      mrp,
      percentProfit,
      plantId,
      processPrice,
      type,
    } = params;
    return {
      input: {
        ...(id && { id }),
        ...(age && { age }),
        ...(compoundInterest && { compoundInterest }),
        ...(moneyId && { moneyId }),
        ...(mrp && { mrp }),
        ...(percentProfit && { percentProfit }),
        ...(plantId && { plantId }),
        ...(processPrice && { processPrice }),
        ...(type && { type }),
      },
    };
  },
  // Get Age ComboBox
  getAgeComboBox: ({ skip, take, age }: IGetAgeComboBox) => {
    return {
      skip,
      take,
      input: {
        ...(age && {
          age: {
            in: age,
          },
        }),
      },
    };
  },

  updateCompoundInterest: (input: IUpdateCompoundInterest) => {
    return {
      input,
    };
  },
};
